import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../../features/modal/modalSlice";

import Modal from "./Modal";

export default function Actions({ title, children }) {
    const { openModal, openModalEdit } = useSelector(state => state.modal)
    const dispatch = useDispatch();
    const close = () => dispatch(closeModal());
    return <Modal open={openModal || openModalEdit} close={close} title={title} children={children} />
}